<eds-proximal
  *ngIf="!isPreviewLayout"
  placement="FundDocumentsTop"
></eds-proximal>
<div edsGrid *ngIf="!isPreviewLayout">
  <div edsRow>
    <ft-literature-dialog
      [dialogId]="ModalIdValue"
      [modalIdEnum]="ModalId['Sticky_Modal']"
      [multiSelectDialogData]="multiSelectDialogData"
      (dialog)="closeDialog($event)"
      (deleteDoc)="deselectedDownloadDocs($event, true)"
      (downloadStart)="startDownload()"
      (emailStart)="startEmail()"
      (modalClose)="closeModal(ModalId['Sticky_Modal'])"
      (backEmail)="emailBack()"
      (continueEmail)="emailContinue($event)"
      (deleteCartDoc)="updateStorage($event)"
      (emptyCart)="emptyCart($event)"
      [gridData]="dialogData"
    ></ft-literature-dialog>
  </div>
</div>

<ng-container *ngIf="isPreviewLayout">
  <ft-literature-preview></ft-literature-preview>
</ng-container>

<ng-container *ngIf="isColumnLayout">
  <div
    edsSubGrid="layout-1"
    edsSubGridDesktop="layout-1"
    edsSubGridDesktopLarge="layout-1"
    edsSubGridGap="lg"
    *ngIf="dataTab?.size > 0"
  >
    <div *ngFor="let data of dataTab | keyvalue: originalOrder; let i = index">
      <eds-title
        [size]="'h3'"
        [level]="3"
        title="{{ 'literature.' + data.key | translate }}"
        edsSpacing="sm"
      >
      </eds-title>
      <ng-container *ngIf="!isMobile">
        <ng-template
          *ngTemplateOutlet="agGrid; context: { data: data }"
        ></ng-template>
      </ng-container>
      <ng-container *ngIf="isMobile">
        <ng-template
          *ngTemplateOutlet="fundDocumentCard; context: { data: data }"
        ></ng-template>
      </ng-container>
    </div>
  </div>
</ng-container>

<!-- this is tabView - displayed when we don't use preview nor Column -->
<ng-container *ngIf="!isColumnLayout && !isPreviewLayout">
  <div edsRow *ngIf="dataTab?.size > 0">
    <div edsCol>
      <eds-tabs
        [followFocus]="true"
        [isNavigation]="false"
        [cacheActive]="true"
        [darkBackground]="true"
        [fullWidth]="true"
        dropdownTheme="handheld"
      >
        <eds-tab
          *ngFor="let data of dataTab | keyvalue: originalOrder"
          heading="{{ 'literature.' + data.key | translate }}"
          (selected)="onSelected()"
        >
          <ng-container *ngIf="data.value.length > 0">
            <div [class.visibility-hidden]="!loaded">
              <ng-container *ngIf="!isHandheld">
                <ng-template
                  *ngTemplateOutlet="agGrid; context: { data: data }"
                ></ng-template>
              </ng-container>
            </div>
            <ng-container *ngIf="isHandheld">
              <ng-template
                *ngTemplateOutlet="fundDocumentCard; context: { data: data }"
              ></ng-template>
            </ng-container>
          </ng-container>
        </eds-tab>
      </eds-tabs>
    </div>
  </div>
</ng-container>

<ng-template #agGrid let-data="data">
  <ag-grid-angular
    #literatureDocumentGrid
    edsSpacing="lg"
    style="width: 100%; height: 100%"
    class="ag-theme-frk ag-theme-frk--dark"
    [rowData]="data.value"
    [columnDefs]="columnDefs"
    [frameworkComponents]="frameworkComponents"
    [rowSelection]="'multiple'"
    [suppressPaginationPanel]="true"
    [suppressRowClickSelection]="true"
    [suppressHorizontalScroll]="true"
    [pagination]="false"
    domLayout="autoHeight"
    [suppressRowHoverHighlight]="true"
    [suppressCellSelection]="false"
    [ensureDomOrder]="true"
    (rowSelected)="onSelectionChanged($event, href, true, true)"
    (gridReady)="onGridReady($event)"
    (gridSizeChanged)="onGridSizeChanged()"
    [enableCellTextSelection]="true"
  >
  </ag-grid-angular>
</ng-template>
<ng-template #fundDocumentCard let-data="data">
  <ft-fund-document-card-container
    [rowData]="data.value"
    [columnDefs]="columnDefs"
    (selectionEmitter)="onSelectionChanged($event, href, false, true)"
    edsRow
  ></ft-fund-document-card-container>
</ng-template>
<eds-sticky-footer
  [itemCount]="rowCountValue"
  [isHide]="rowCount === 0"
  variation="2"
  [primaryAction]="emailStickyButton"
  [secondaryAction]="downloadStickyButton"
  [tertiaryAction]="addToCartStickyButton"
  (btnSubscribePrimary)="operationToPerform('email')"
  (btnSubscribeSecond)="operationToPerform('download')"
  (btnSubscribeThird)="operationToPerform('addToCart')"
  [stickyFooterName]="'document_listing_sticky_footer'"
  *ngIf="!isPreviewLayout"
></eds-sticky-footer>

<div edsRow *ngIf="!isPreviewLayout && dataTab?.size === 0">
  <div edsCol>
    <div edsPadding edsPaddingAll="lg">
      <span>
        {{ "literature.lit-error-message" | translate }}
      </span>
    </div>
  </div>
</div>
<eds-proximal
  *ngIf="!isPreviewLayout"
  placement="FundDocumentBottom"
></eds-proximal>
